import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaInfoCircle, FaHistory, FaPhoneAlt } from 'react-icons/fa';
import { VoIPDevice } from '../utils/voipTypes';

interface VoIPDeviceTableProps {
  devices: VoIPDevice[];
  onDeviceClick: (device: VoIPDevice) => void;
}

const VoIPDeviceTable: React.FC<VoIPDeviceTableProps> = ({ devices, onDeviceClick }) => {
  const navigate = useNavigate();

  const getStatusBadge = (status: string) => {
    const statusClass = status === 'online' ? 'up' : status === 'offline' ? 'down' : 'warning';
    return <span className={`status-badge ${statusClass}`}>{status}</span>;
  };

  const getRegStatusBadge = (status: string) => {
    const statusClass = status === 'registered' ? 'up' : status === 'failed' ? 'down' : 'warning';
    return <span className={`reg-badge ${statusClass}`}>{status}</span>;
  };

  const getVendorBadge = (vendor?: string) => {
    if (!vendor || vendor === 'UNKNOWN') {
      return <span className="vendor-badge unknown">-</span>;
    }
    const vendorClass = vendor.toLowerCase();
    return <span className={`vendor-badge ${vendorClass}`}>{vendor}</span>;
  };

  if (devices.length === 0) {
    return (
      <div className="no-data">
        <div className="no-data-icon"><FaPhoneAlt /></div>
        <h3>No VoIP devices found</h3>
      </div>
    );
  }

  return (
    <div className="table-container">
      <div className="table-header">
        <div className="table-title">
          VoIP Devices <span>Real-time status monitoring</span>
        </div>
        <div className="table-count">{devices.length} devices</div>
      </div>
      <div className="table-scroll">
        <table className="voip-table">
          <thead>
            <tr>
              <th>Device</th>
              <th>Station</th>
              <th>Vendor</th>
              <th>Status</th>
              <th>Registration</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {devices.map((device) => {
              return (
                <tr key={device.id} onClick={() => onDeviceClick(device)}>
                  <td>
                    <div className="device-name-cell">
                      <div className="device-name">{device.name}</div>
                      <div className="device-ip">{device.ipAddress}</div>
                    </div>
                  </td>
                  <td>
                    <span className="station-badge">{device.station}</span>
                  </td>
                  <td>{getVendorBadge(device.vendor)}</td>
                  <td>{getStatusBadge(device.status)}</td>
                  <td>{getRegStatusBadge(device.registrationStatus)}</td>
                  <td>
                    <div className="actions-cell">
                      <button
                        className="action-btn detail"
                        onClick={(e) => {
                          e.stopPropagation();
                          onDeviceClick(device);
                        }}
                        title="View Details"
                      >
                        <FaInfoCircle />
                      </button>
                      <button
                        className="action-btn history"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/voip-device-history/${device.deviceId}`);
                        }}
                        title="View History"
                      >
                        <FaHistory />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VoIPDeviceTable;
